import MediaClient from '@stratumn/media-sdk';
import { MEDIA_API_URL } from 'constant/api';
import {
  ROUTE_CHECK_INVITE,
  ROUTE_CONDUENT_LOGIN,
  ROUTE_CONDUENT_SIGNUP,
  ROUTE_GOOGLE_AUTH,
  ROUTE_INVITE_PASSWORDRESET,
  ROUTE_INVITE_SIGNUP,
  ROUTE_INVITE_SIGNUP_PENDING,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_PASSWORD_RESET,
  ROUTE_PASSWORD_UPDATE,
  ROUTE_REVOKE_SIGNUP,
  ROUTE_SIGNUP
} from 'constant/routes';
import { SpanType, withSpanAsync } from 'tracing';
import Fetcher from 'utils/fetcher';

const mediaClient = new MediaClient(MEDIA_API_URL);

export default class Client {
  constructor(rootUrl, history) {
    const fetcher = new Fetcher(history);
    this._get = (path, data, errorOptions) =>
      fetcher.get(`${rootUrl}${path}`, data, errorOptions);
    this._post = (path, data, headers, errorOptions) =>
      fetcher.post(`${rootUrl}${path}`, data, headers, errorOptions);
  }

  media = mediaClient;

  login = async (email, password, oauthPayload, stayLoggedIn) =>
    withSpanAsync('login', SpanType.outgoingRequest, async () => {
      const { token, authCode, redirectUri } = await this._post(ROUTE_LOGIN, {
        email,
        password,
        oauthPayload,
        stayLoggedIn
      });

      return { token, authCode, redirectUri };
    });

  loginConduent = async (username, password, oauthPayload, stayLoggedIn) =>
    withSpanAsync('loginConduent', SpanType.outgoingRequest, async () => {
      const { token, authCode, redirectUri } = await this._post(
        ROUTE_CONDUENT_LOGIN,
        {
          username,
          password,
          oauthPayload,
          stayLoggedIn
        },
        undefined,
        { redirectOn401: false, displayErrorMessage: false }
      );

      return { token, authCode, redirectUri };
    });

  logout = async () =>
    withSpanAsync('logout', SpanType.outgoingRequest, async () =>
      this._get(ROUTE_LOGOUT)
    );

  signup = async (firstName, lastName, password, invitationToken) =>
    withSpanAsync('signup', SpanType.outgoingRequest, async () => {
      const { token } = await this._post(ROUTE_SIGNUP, {
        firstName,
        lastName,
        password,
        invitationToken
      });

      return token;
    });

  signupConduent = async (
    firstName,
    lastName,
    username,
    password,
    invitationToken
  ) =>
    withSpanAsync('signup', SpanType.outgoingRequest, async () => {
      const { token } = await this._post(
        ROUTE_CONDUENT_SIGNUP,
        {
          firstName,
          lastName,
          username,
          password,
          invitationToken
        },
        undefined,
        { redirectOn401: false, displayErrorMessage: false }
      );

      return token;
    });

  oAuth = async (state, code, oauthPayload) =>
    withSpanAsync('oauth', SpanType.outgoingRequest, async () => {
      const { token, authCode, redirectUri } = await this._post(
        ROUTE_GOOGLE_AUTH,
        {
          state,
          code,
          oauthPayload
        }
      );

      return { token, authCode, redirectUri };
    });

  invite = email =>
    withSpanAsync('invite', SpanType.outgoingRequest, () =>
      this._post(ROUTE_INVITE_SIGNUP, { email })
    );

  pendingInvitations = () =>
    withSpanAsync('pendingInvitations', SpanType.outgoingRequest, () =>
      this._get(ROUTE_INVITE_SIGNUP_PENDING)
    );

  revokeInvitation = token =>
    withSpanAsync('revokeInvitation', SpanType.outgoingRequest, () =>
      this._post(ROUTE_REVOKE_SIGNUP, { token })
    );

  forgot = email =>
    withSpanAsync('forgot', SpanType.outgoingRequest, () =>
      this._post(ROUTE_INVITE_PASSWORDRESET, { email })
    );

  reset = (password, invitationToken) =>
    withSpanAsync('reset', SpanType.outgoingRequest, async () => {
      const { token } = await this._post(ROUTE_PASSWORD_RESET, {
        password,
        invitationToken
      });
      return token;
    });

  updatePassword = (email, oldPassword, newPassword) =>
    withSpanAsync('updatePassword', SpanType.outgoingRequest, async () =>
      this._post(ROUTE_PASSWORD_UPDATE, {
        oldPassword,
        newPassword
      })
    );

  checkInvite = token =>
    withSpanAsync('checkInvite', SpanType.outgoingRequest, () =>
      this._post(ROUTE_CHECK_INVITE, { token })
    );
}
